/* @generated */
import * as React from "react";
import { ThemeProvider } from "../theme/theme.esm.js";
const defaultValue = {};
const DIGContext = React.createContext(defaultValue);
function isFeatureLevelSupported(currentLevel) {
  return !!currentLevel && currentLevel.toLocaleLowerCase() === "experimental";
}
const DIGProvider = (props) => {
  const { featureProviderProps, themeProviderProps, children } = props;
  return /* @__PURE__ */ React.createElement(DIGContext.Provider, { value: featureProviderProps || {} }, themeProviderProps ? /* @__PURE__ */ React.createElement(ThemeProvider, { ...themeProviderProps }, children) : children);
};
export {
  DIGContext,
  DIGProvider,
  isFeatureLevelSupported
};
